
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#666"}},[_c('path',{attrs:{"d":"M16.911.304a.625.625 0 01-.214.857l-2.59 1.553 1.554 2.59a.625.625 0 01-1.072.643l-1.875-3.125a.625.625 0 01.214-.858L16.053.09a.625.625 0 01.858.215z"}}),_c('path',{attrs:{"d":"M13.586 2.52a6.249 6.249 0 016.375 4.09.625.625 0 01-1.175.428 5 5 0 00-5.099-3.272.625.625 0 11-.1-1.246zM4.554 13.84a.625.625 0 01.857.213l1.875 3.125a.625.625 0 01-.214.858l-3.125 1.875a.625.625 0 01-.643-1.072l2.589-1.553-1.554-2.59a.625.625 0 01.215-.857z"}}),_c('path',{attrs:{"d":"M.411 12.589a.625.625 0 01.801.373 5 5 0 005.1 3.272.625.625 0 01.1 1.246 6.25 6.25 0 01-6.374-4.09.625.625 0 01.373-.801zM0 .625C0 .28.28 0 .625 0h10c.345 0 .625.28.625.625v10c0 .345-.28.625-.625.625h-10A.625.625 0 010 10.625v-10zm1.25.625V10H10V1.25H1.25z"}}),_c('path',{attrs:{"d":"M12.5 9.375c0-.345.28-.625.625-.625h5A1.875 1.875 0 0120 10.625v7.5A1.875 1.875 0 0118.125 20h-7.5a1.875 1.875 0 01-1.875-1.875v-5a.625.625 0 111.25 0v5a.624.624 0 00.625.625h7.5a.624.624 0 00.625-.625v-7.5a.624.624 0 00-.625-.625h-5a.625.625 0 01-.625-.625z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    